import { Link } from 'react-router-dom';

import { List } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ManageFields({ info }) {
  const { row } = getInfo(info)
  return <>
    <DefaultTooltip content='Manage Fields' side='left'>
      <Link to={`/offer/forms/${row.id}/fields`} >
        <List size={16} />
      </Link>
    </DefaultTooltip>
  </>
}
